import { render, staticRenderFns } from "./FileDataForm.vue?vue&type=template&id=b228d474&"
import script from "./FileDataForm.vue?vue&type=script&lang=js&"
export * from "./FileDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QToggle,QInput,QSelect,QItem,QItemSection,QIcon,QItemLabel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QToggle,QInput,QSelect,QItem,QItemSection,QIcon,QItemLabel})
